/**
 * @generated SignedSource<<43a933cd4dbe5d7ec82daff6b4bf69a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductRegistrationAvailability = "hidden" | "private" | "public" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductSelectFragment$data = {
  readonly badge: {
    readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
  } | null;
  readonly hasEventsApp?: boolean;
  readonly id: string;
  readonly isAutoJoined: boolean;
  readonly name: string;
  readonly registrationAvailability: ProductRegistrationAvailability;
  readonly slug: string;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDropdownItemFragment">;
  readonly " $fragmentType": "ProductSelectFragment";
};
export type ProductSelectFragment$key = {
  readonly " $data"?: ProductSelectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSelectFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hideNonEventAppProducts"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSelectFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAutoJoined",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerPermissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationAvailability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Badge",
      "kind": "LinkedField",
      "name": "badge",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BadgeFragment"
        }
      ],
      "storageKey": null
    },
    {
      "condition": "hideNonEventAppProducts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "hasEventsApp",
          "args": [
            {
              "kind": "Literal",
              "name": "kind",
              "value": "events"
            }
          ],
          "kind": "ScalarField",
          "name": "hasProductApp",
          "storageKey": "hasProductApp(kind:\"events\")"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDropdownItemFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "690fd9a216447ca55c6d435edf6ecfe2";

export default node;
